"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var domUtils_1 = require("../tools/domUtils");
var AutoSuggest = (function () {
    function AutoSuggest() {
        this.box = document.createElement('div');
        this.ARROWDOWN = 40;
        this.ARROWUP = 38;
        this.ENTER = 13;
        this.TAB = 9;
        this.boxOpen = false;
        this.activeField = null;
        this.currentValue = null;
        this.debounceId = null;
        this.caches = {
            'default': {}
        };
        this.box.classList.add('suggest-box');
        this.box.appendChild(document.createElement('ul'));
        this.box.style.display = 'none';
        var eventHandler = this.handleEvent.bind(this);
        domUtils_1.on('keydown', '.suggest', eventHandler);
        domUtils_1.on('keyup', '.suggest', eventHandler);
        domUtils_1.on('paste cut input', '.suggest', eventHandler);
        domUtils_1.on('focus focusin', '.suggest', eventHandler);
        domUtils_1.on('blur focusout', '.suggest', eventHandler);
        domUtils_1.on('mouseover', '.suggest-box li', eventHandler);
        domUtils_1.on('mousedown', '.suggest-box li', eventHandler);
        window.addEventListener('resize', eventHandler);
    }
    AutoSuggest.getInstance = function () {
        if (!this.instance) {
            this.instance = new AutoSuggest();
        }
        return this.instance;
    };
    AutoSuggest.prototype.hide = function () {
        this.box.style.display = 'none';
        this.boxOpen = false;
        this.activeField = null;
    };
    AutoSuggest.prototype.show = function () {
        var _this = this;
        document.documentElement.appendChild(this.box);
        this.box.style.display = 'block';
        this.boxOpen = true;
        if (this.activeField && this.activeField.getAttribute("data-css-only")) {
            this.box.removeAttribute("style");
            this.box.classList.add("suggest-css-only");
            this.box.classList.remove("suggest-positioned");
        }
        else {
            this.box.classList.remove("suggest-css-only");
            this.box.classList.add("suggest-positioned");
            this.position();
        }
        var hideHandler = function () {
            _this.hide();
            document.removeEventListener('click', hideHandler);
        };
        document.addEventListener('click', hideHandler);
    };
    AutoSuggest.prototype.handleEvent = function (event) {
        if (event.type !== 'mousedown'
            && event.type !== 'mouseover'
            && event.type !== 'resize') {
            this.activeField = event.target;
        }
        switch (event.type) {
            case 'keydown':
                this.handleKeydown(event);
                break;
            case 'keyup':
                this.handleKeyup(event);
                break;
            case 'paste':
            case 'cut':
            case 'input':
                this.processSuggestions();
                break;
            case 'mouseover':
                this.select(event.target);
                break;
            case 'blur':
            case 'focusout':
                this.clearState();
                break;
            case 'resize':
                if (this.activeField && !this.activeField.getAttribute("data-css-only")) {
                    this.position();
                }
                break;
            case 'mousedown':
                this.handleInsert(event);
                break;
            default:
        }
    };
    AutoSuggest.prototype.handleKeydown = function (event) {
        switch (event.which) {
            case this.ENTER:
            case this.TAB:
                this.handleInsert(event);
                break;
            case this.ARROWUP:
                event.preventDefault();
                this.selectUp();
                break;
            case this.ARROWDOWN:
                event.preventDefault();
                this.selectDown();
                break;
            default:
        }
    };
    AutoSuggest.prototype.handleKeyup = function (event) {
        if (event.which === this.ENTER
            || event.which === this.TAB) {
            return;
        }
        this.processSuggestions();
    };
    AutoSuggest.prototype.processSuggestions = function () {
        clearTimeout(this.debounceId);
        this.debounceId = setTimeout(this.determineSuggestions.bind(this), AutoSuggest.debounceTime);
    };
    AutoSuggest.prototype.determineSuggestions = function () {
        if (!this.activeField) {
            return;
        }
        var value = this.activeField.value.trim();
        if (value.length <= 1) {
            this.hide();
        }
        else if (value !== this.currentValue) {
            this.loadSuggestions(value);
        }
        this.currentValue = value;
    };
    AutoSuggest.prototype.clearState = function () {
        this.hide();
        this.currentValue = null;
        clearTimeout(this.debounceId);
    };
    AutoSuggest.prototype.loadSuggestions = function (value) {
        var cache = this.getCache();
        if (value in cache) {
            this.renderSuggestions(cache[value]);
        }
        else {
            this.box.innerHTML = '';
            document.querySelector('.search-bar').classList.add('loading');
            this.sendRequest();
        }
    };
    AutoSuggest.prototype.sendRequest = function () {
        var _this = this;
        if (!this.activeField) {
            return;
        }
        var cache = this.getCache();
        var url = this.activeField.getAttribute('data-url');
        var param = this.activeField.getAttribute('data-param');
        var value = this.activeField.value.trim();
        try {
            fetch(url, {
                method: 'POST',
                credentials: 'include',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8'
                },
                body: param + "=" + value
            })
                .then(function (res) { return res.json(); })
                .then(function (json) {
                cache[value] = json;
                _this.renderSuggestions(json);
            })
                .then(function () { return _this.clearRequest(); });
        }
        catch (e) {
            console.error(e);
        }
    };
    AutoSuggest.prototype.getCache = function () {
        var ns = this.activeField.getAttribute('data-cache-ns') || 'default';
        return this.caches[ns] || (this.caches[ns] = {});
    };
    AutoSuggest.prototype.clearRequest = function () {
        document.querySelector('.search-bar').classList.remove('loading');
    };
    AutoSuggest.prototype.renderSuggestions = function (response) {
        var html = '';
        if (response.length === 0) {
            this.hide();
            return;
        }
        var suggestions = response.concat();
        while (suggestions.length) {
            html = html.concat("<li>" + suggestions.shift() + "</li>");
        }
        this.box.innerHTML = html;
        this.show();
    };
    AutoSuggest.prototype.handleInsert = function (event) {
        var value = this.box.querySelector('.selected').textContent.trim();
        if (value && this.boxOpen) {
            event.preventDefault();
            this.activeField.value = value;
        }
        this.hide();
    };
    AutoSuggest.prototype.select = function (element) {
        var listItems = this.box.querySelectorAll('li');
        var listItemCount = listItems.length;
        for (var i = 0; i < listItemCount; ++i) {
            listItems[i].classList.remove('selected');
        }
        var listItem = element;
        if (listItem.tagName !== 'LI') {
            listItem = element.closest('li');
        }
        listItem.classList.add('selected');
    };
    AutoSuggest.prototype.selectUp = function () {
        var curSelected = this.box.querySelector('.selected');
        var prev = curSelected ? curSelected.previousElementSibling : curSelected;
        if (curSelected) {
            curSelected.classList.remove('selected');
        }
        if (prev) {
            prev.classList.add('selected');
        }
        else {
            var listItem = this.box.querySelector('li:last-of-type');
            if (listItem) {
                listItem.classList.add('selected');
            }
        }
    };
    AutoSuggest.prototype.selectDown = function () {
        var curSelected = this.box.querySelector('.selected');
        var next = curSelected ? curSelected.nextElementSibling : curSelected;
        if (curSelected) {
            curSelected.classList.remove('selected');
        }
        if (next) {
            next.classList.add('selected');
        }
        else {
            var listItem = this.box.querySelector('li:first-of-type');
            if (listItem) {
                listItem.classList.add('selected');
            }
        }
    };
    AutoSuggest.prototype.position = function () {
        if (!this.activeField) {
            return;
        }
        var bbox = this.activeField.getBoundingClientRect();
        var x = bbox.left;
        var y = (bbox.top + this.activeField.offsetHeight + (document.body.scrollTop || document.documentElement.scrollTop));
        this.box.style.position = 'absolute';
        this.box.style.left = x + "px";
        this.box.style.top = y + "px";
        this.box.style.width = this.activeField.offsetWidth + "px";
    };
    AutoSuggest.debounceTime = 100;
    return AutoSuggest;
}());
exports.AutoSuggest = AutoSuggest;
